module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('transition', {
    attrs: {
      "name": "lightbox"
    }
  }, [_c('div', {
    staticClass: "lightbox"
  }, [_c('div', {
    staticClass: "lightbox-mask"
  }, [(_vm.photoUrl) ? _c('div', {
    staticClass: "lightbox-photo",
    style: ({
      backgroundImage: 'url(' + _vm.photoUrl + ')'
    })
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "lightbox-close-button icon-cross",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-250542da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lightbox.vue
// module id = 195
// module chunks = 5